export const getAdminClientRoles = () =>
  process.env.REACT_APP_KEYCLOAK_REALM_MANAGEMENT_CLIENT_ROLES.split(",").map(
    (entry) => ({
      id: entry.split(":")[0],
      name: entry.split(":")[1],
    })
  );
